<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
export default {
  mounted() {
    console.log('客户端版本信息:',navigator.userAgent)
  },
}
</script>
<style lang="less" scoped>
#app {
  width: 100%;
  height: 100%;
}
</style>
